/**
 * @readonly
 * @enum {string}
 */
export const ThemeScope = {
  CLIENT: "CLIENT",
  GAME: "GAME"
}
